// extracted by mini-css-extract-plugin
export default {"root":"root__YXnDd9ZBHqd2","avatar":"avatar__A1vIxsdwumKY","scrollableList":"scrollableList__RYdyaM_Y11Xj"};